/**
 * Histories slice (SCRUM-1951, RTK bundle 2) — the former switch reducer
 * historiesReducer.js as createSlice. Behaviour-preserving: every case answers
 * the same legacy action type string (historiesTypes.js) that historiesActions.js
 * already dispatches, and returns the same state. The actions module is
 * unchanged, so deleteHistory keeps its resolve/reject contract and no importer
 * changes. `CLEAR_MESSAGE` is the same string pendingPages answers to; each
 * slice clears its own message, as the two switch reducers did.
 * Characterised by tests/integration/reducers/reviewPublishingReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  GET_HISTORIES,
  CLEAR_MESSAGE,
  DELETE_HISTORY,
  CLEAR_HISTORY,
} from "./historiesTypes";
import type { MessageResponse } from "../../../../shared/apiTypes";

type HistoriesState = {
  histories: any[];
  message: string;
};

const initialState: HistoriesState = {
  histories: [],
  message: "",
};

const historiesSlice = createSlice({
  name: "histories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_MESSAGE, (state) => ({ ...state, message: "" }))
      .addCase(GET_HISTORIES, (state, action: PayloadAction<HistoriesState["histories"], typeof GET_HISTORIES>) => ({
        ...state,
        histories: action.payload,
      }))
      .addCase(DELETE_HISTORY, (state, action: PayloadAction<MessageResponse, typeof DELETE_HISTORY>) => ({
        ...state,
        message: action.payload.msg,
      }))
      .addCase(CLEAR_HISTORY, (state, action: PayloadAction<MessageResponse, typeof CLEAR_HISTORY>) => ({
        ...state,
        message: action.payload.msg,
      }));
  },
});

export default historiesSlice.reducer;
